module.exports = __webpack_public_path__ + "images/e1e8092ba005f4486aa357a7e50162fe.webp";